import { queryKeys } from "../queryKeys";
import {
  type GetCurrencyCloudAccountResponse,
  type GetCurrencyCloudBeneficiaryResponse,
  type GetCurrencyCloudStatusResponse,
  getCurrencyCloudAccount,
  getCurrencyCloudBeneficiaryRequiredDetails,
  getCurrencyCloudStatus,
} from "../rest/currencyCloud";
import useRequest, { type QueryOptions } from "./useRequest";

type UseGetCurrencyCloudAccountProps = {
  accountID: string;
  options?: QueryOptions<GetCurrencyCloudAccountResponse>;
};

export const useGetCurrencyCloudAccount = ({
  accountID,
  options,
}: UseGetCurrencyCloudAccountProps) => {
  const cc = useRequest(
    queryKeys.currencyCloud.account(accountID),
    () => getCurrencyCloudAccount(accountID),
    {
      ...options,
      enabled: !!accountID && (options?.enabled ?? true),
    },
  );

  return cc;
};

type UseGetCurrencyCloudBeneficiaryProps = {
  accountID: string;
  options?: QueryOptions<GetCurrencyCloudBeneficiaryResponse>;
};

export const useGetCurrencyCloudBeneficiaryRequiredDetails = ({
  accountID,
  options,
}: UseGetCurrencyCloudBeneficiaryProps) => {
  const ccBeneficiaryRequiredDetails = useRequest(
    queryKeys.currencyCloud.beneficiaryRequiredDetails(accountID),
    () => getCurrencyCloudBeneficiaryRequiredDetails(accountID),
    {
      ...options,
      enabled: !!accountID && (options?.enabled ?? true),
    },
  );

  return ccBeneficiaryRequiredDetails;
};

type UseGetCurrencyCloudStatusProps = {
  accountID: string;
  options?: QueryOptions<GetCurrencyCloudStatusResponse>;
};

export const useGetCurrencyCloudStatus = ({
  accountID,
  options,
}: UseGetCurrencyCloudStatusProps) => {
  const ccStatus = useRequest(
    queryKeys.currencyCloud.status(accountID),
    () => getCurrencyCloudStatus(accountID),
    {
      ...options,
      enabled: !!accountID && (options?.enabled ?? true),
    },
  );

  return ccStatus;
};
